import { colors } from '../../colors';
var anchor = {
  anchorColor: colors.pine
};
export default anchor;